import React from 'react';

import { TextField, Typography } from '@material-ui/core';
import PropTypes from 'prop-types';

import { t, number } from '~/helpers';

import * as S from './styles';

/**
 * LEGEND (error)
 *
 * (1) Divergência de volume
 */
export default function Tanques({
  tanque,
  sending,
  onForm,
  error,
  position,
  close,
  visible,
  toggleDisabled,
}) {
  const [justificativa, setJustificativa] = React.useState('');
  const [erroJustificativa, setErroJustificativa] = React.useState(false);
  const [informaJustificativa, setInformaJustificativa] = React.useState(false);
  const justificativaExcedeLimite = justificativa.length > 200;
  let textoAjudaJustificativa = `${justificativa.length}/200 caracteres`;

  if (erroJustificativa) {
    textoAjudaJustificativa = `${t(
      's.operacao.turno.justificativadivergenciavolumeobrigatoria'
    )} ${justificativa.length}/200 caracteres`;
  }

  if (justificativaExcedeLimite) {
    textoAjudaJustificativa = `${t(
      's.operacao.turno.justificativadivergenciavolumeinvalida'
    )} ${justificativa.length}/200 caracteres`;
  }

  React.useEffect(() => {
    if (!visible) {
      setJustificativa('');
      setErroJustificativa(false);
      setInformaJustificativa(false);
    }
  }, [visible]);

  React.useEffect(() => {
    toggleDisabled(
      error === 3 && informaJustificativa && justificativaExcedeLimite
    );

    return () => toggleDisabled(false);
  }, [error, informaJustificativa, justificativaExcedeLimite, toggleDisabled]);

  React.useEffect(() => {
    if (sending) {
      if (error === 3 && !informaJustificativa) {
        setInformaJustificativa(true);
        return;
      }

      if (error === 3 && !justificativa.trim()) {
        setErroJustificativa(true);
        return;
      }

      if (error === 3 && justificativaExcedeLimite) {
        setErroJustificativa(true);
        return;
      }

      onForm({ position, error, justificativa: justificativa.trim() });
      close();
    }
  }, [
    sending,
    error,
    justificativa,
    informaJustificativa,
    justificativaExcedeLimite,
    onForm,
    position,
    close,
  ]);

  if (error === 1)
    return (
      <S.Wrapper>
        <Typography>
          {t('s.operacao.turno.divergenciavolume').replace(
            '%',
            tanque.codigotanquefisico
          )}
        </Typography>
        <S.WrapperGroupInput>
          <TextField
            fullWidth
            disabled
            size="small"
            variant="outlined"
            label={t('s.operacao.turno.alturatanquefisico')}
            value={number(tanque.alturatanquefisico, 1)}
          />

          <TextField
            fullWidth
            disabled
            size="small"
            variant="outlined"
            label={t('s.operacao.turno.volumetanquefisico')}
            value={number(tanque.volumetanquefisico, 1)}
          />
        </S.WrapperGroupInput>
      </S.Wrapper>
    );

  if (error === 3)
    return (
      <S.Wrapper>
        <Typography gutterBottom>
          {informaJustificativa
            ? t('s.operacao.turno.justificativadivergenciavolume')
            : t('s.operacao.turno.confirmadivergenciasturno')}
        </Typography>

        {informaJustificativa && (
          <TextField
            autoFocus
            fullWidth
            required
            multiline
            rows={4}
            // variant="outlined"
            label="Justificativa"
            value={justificativa}
            error={erroJustificativa || justificativaExcedeLimite}
            helperText={textoAjudaJustificativa}
            onChange={(event) => {
              setJustificativa(event.target.value);
              setErroJustificativa(false);
            }}
            FormHelperTextProps={{ style: { marginTop: 8 } }}
          />
        )}
      </S.Wrapper>
    );

  return (
    <S.Wrapper>
      <Typography>
        {t('s.operacao.turno.divergenciavolumeturnoAnterior')}
      </Typography>
    </S.Wrapper>
  );
}

Tanques.propTypes = {
  tanque: PropTypes.objectOf({
    idtanquefisico: PropTypes.number,
    alturatanquefisico: PropTypes.number,
    volumetanquefisico: PropTypes.number,
    alturaaguatanquefisico: PropTypes.number,
    volumeaguatanquefisico: PropTypes.number,
    codigotanquefisico: PropTypes.string,
  }),
  sending: PropTypes.bool.isRequired,
  onForm: PropTypes.func.isRequired,
  error: PropTypes.number,
  position: PropTypes.number,
  close: PropTypes.func.isRequired,
  visible: PropTypes.bool.isRequired,
  toggleDisabled: PropTypes.func.isRequired,
};

Tanques.defaultProps = {
  tanque: {
    idtanquefisico: 0,
    alturatanquefisico: 0,
    volumetanquefisico: 0,
    alturaaguatanquefisico: 0,
    volumeaguatanquefisico: 0,
    codigotanquefisico: '',
  },
  error: 1,
  position: 0,
};
